export abstract class TechnicalSpecificationsSectionsState {
  constructor(state?: any) {
    this.application_id = state?.application_id;
    this.is_base_data_locked = state ? JSON.parse(state.is_base_data_locked) : null;
    this.base_data_comment = state?.base_data_comment;
    this.is_existing_energy_producer_locked = state ? JSON.parse(state.is_existing_energy_producer_locked) : null;
    this.existing_energy_producer_comment = state?.existing_energy_producer_comment;
    this.is_detailed_info_photovoltaics_locked = state ? JSON.parse(state.is_detailed_info_photovoltaics_locked) : null;
    this.detailed_info_photovoltaics_comment = state?.detailed_info_photovoltaics_comment;
    this.is_detailed_info_energy_producer_locked = state ? JSON.parse(state.is_detailed_info_energy_producer_locked) : null;
    this.detailed_info_energy_producer_comment = state?.detailed_info_energy_producer_comment;
    this.is_detailed_info_storage_locked = state ? JSON.parse(state.is_detailed_info_storage_locked) : null;
    this.detailed_info_storage_comment = state?.detailed_info_storage_comment;
    this.is_detailed_info_grid_power_plant_locked = state ? JSON.parse(state.is_detailed_info_grid_power_plant_locked) : null;
    this.detailed_info_grid_power_plant_comment = state?.detailed_info_grid_power_plant_comment;
    this.is_type_of_feed_in_locked = state ? JSON.parse(state.is_type_of_feed_in_locked) : null;
    this.type_of_feed_in_comment = state?.type_of_feed_in_comment;
    this.is_feed_in_controllability_locked = state ? JSON.parse(state.is_feed_in_controllability_locked) : null;
    this.feed_in_controllability_comment = state?.feed_in_controllability_comment;
    this.is_concept_of_measurement_locked = state ? JSON.parse(state.is_concept_of_measurement_locked) : null;
    this.concept_of_measurement_comment = state?.concept_of_measurement_comment;
    this.is_meter_operation_locked = state ? JSON.parse(state.is_meter_operation_locked) : null;
    this.meter_operation_comment = state?.meter_operation_comment;
  }

  application_id: number | null;
  is_base_data_locked: boolean | null;
  base_data_comment: string | null;
  is_existing_energy_producer_locked: boolean | null;
  existing_energy_producer_comment: string | null;
  is_detailed_info_photovoltaics_locked: boolean | null;
  detailed_info_photovoltaics_comment: string | null;
  is_detailed_info_energy_producer_locked: boolean | null;
  detailed_info_energy_producer_comment: string | null;
  is_detailed_info_storage_locked: boolean | null;
  detailed_info_storage_comment: string | null;
  is_detailed_info_grid_power_plant_locked: boolean | null;
  detailed_info_grid_power_plant_comment: string | null;
  is_type_of_feed_in_locked: boolean | null;
  type_of_feed_in_comment: string | null;
  is_feed_in_controllability_locked: boolean | null;
  feed_in_controllability_comment: string | null;
  is_concept_of_measurement_locked: boolean | null;
  concept_of_measurement_comment: string | null;
  is_meter_operation_locked: boolean | null;
  meter_operation_comment: string | null;
}

/* The NULL value indicates the comment is untouched or intentionally left with no value - it must be neither lock nor unlock
  https://github.com/bittner-krull/gop-web/issues/412 */
